import React from 'react';
import {useTranslation} from "react-i18next";

interface Props {
    order: any
}

const SummaryContactComponent = (props: Props) => {
    const {t} = useTranslation();

    const hasContactInformation = () => {
        if(!props.order.contact) return false;

        return Object.entries(props.order.contact).some(([key, value]) => value);
    }

    if(!(hasContactInformation())) return null;

    return (
        <div className={"card-cart"}>
            <div className={"container-fluid"}>
                <h3 className={"card-cart-header"}>{t("common.word.your_data")}</h3>
                <div className={"card-cart-body"}>
                    <div className={"cart-card-info"}>
                        <dl>
                            <dt>{t("common.word.full_name")}:</dt>
                            <dd>{props.order.contact.name}</dd>
                        </dl>
                        <dl>
                            <dt>{t("common.word.email")}:</dt>
                            <dd>{props.order.contact.email}</dd>
                        </dl>
                        <dl>
                            <dt>{t("common.word.phone_number")}:</dt>
                            <dd>{props.order.contact.phone}</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SummaryContactComponent;